<template>
<div class="content">
    <div class="container-fluid">
      <!-- https://getbootstrap.com/docs/4.0/components/navbar/ -->
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <span class="navbar-brand h1">Liste des operations</span>
        <li class="nav-item nav-link">
          <form class="form-inline my-1 my-lg-2">
            <input v-model="filter" class="form-control mr-sm-2" type="search" placeholder="Chercher" aria-label="Chercher">
          </form>
        </li>
        <li class="nav-item nav-link">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-2"
            ></b-pagination>
        </li>
        <li class="na-item nav-link">
          <span>{{ totalRows }} / {{ totalInitial }}</span>
        </li>

      </nav>
        
        <div>
        <b-table striped hover 
          responsive
          v-if="items.length>0"
          :items="items" 
          :fields="columns" 
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          @filtered="onFiltered"
          
          
          > 
          <!-- show-empty -->
          <!-- stacked="md" -->
          <!-- small -->

          <!-- A virtual column --> 
          <template #cell(_status)="row">
            <status-icon :status="row.item._status" />
          </template>
          <template #cell(company.name)="row">
            <router-link :to="urlWithRedirect('/admin/company/'+row.item.company.id)" >{{row.item.operation.company.name}} </router-link>
          </template>
          <template #cell(operation.operationname)="row">
            <router-link v-if="!row.item.id && row.item.operation" :to="urlWithRedirect('/ppe_eu/operation_home/'+row.item.operation.id)" 
              ><b>{{row.item.operation.code }}</b> <div>{{row.item.operation.operationname}}</div> </router-link>
          </template>
          <template #cell(operation.type)="row">
                {{typeToText(row.item.operation.type)}}
          </template>
          <template #cell(operation._modified)="row">
            {{toDate(row.item.operation._modified)}}            
          </template>
          <template #cell(index)="row">
            {{getFullIndexInTable(row.index +1) }}            
          </template>
          <template #cell(img)="row">
            <img height="80px" v-if="row.item.operation.image && row.item.operation.image.length" :src="row.item.operation.image[0].url" /> 
          </template>
        </b-table>
        </div>
        
    </div>
  </div>
</template>

<style>
.table > tbody > tr > td:last-child {
  width: auto;
}
</style>

<script>
import StatusIcon from '../../components/StatusIcon.vue'

const Business = require('ppe-business')

import common from '../common/pages.js'

export default {
  components: {
    StatusIcon,
  },

  data() {
    return { 
      
      items : [ ],
      columns: [
          'index',
          {key:'_status',                 label:'Etat',    sortable: true,}, 
          //{key:'operation.code',          label:'Code',    sortable: true,}, 
          {key:'operation.operationname', label:'Operation', sortable: true,}, 
          {key:'company.name',            label:'EU',       sortable: true,},
          {key:'operation.sitename',      label:'Nom',      sortable: true,}, 
          {key:'operation._modified',     label:'Modifié',      sortable: true,}, 
          {key:'operation.city',          label:'Ville',    sortable: true,},
          {key:'operation.type',          label:'Nature',   sortable: true,},
          //{key:'operation.AKCsync',       label:'Sync AKC', sortable: true,}, 
          {key:'img',                      label:'Img',      sortable: false,}, 
          ],
      filter: null,
      currentPage:1,
      totalRows:0,
      totalInitial:0,
      perPage:20,

      
    }
  },

  mounted() {
      this.$http.get('/admin/operations')
        .then(response => {
          console.log("/admin/operations", response.data)
          var i = 1
          // Map the result to add the _rowVariant attribute to color the full line
          this.items = response.data.operations.map( function (a)  { 
            // https://bootstrap-vue.org/docs/components/table#items-record-data
            return {...a, _rowVariant:Business.getStatusClass(a._status)} } )
          this.totalRows = this.items.length
          this.totalInitial = this.totalRows
          } )
        .catch( (err, res) => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          //console.error("PPEHome.vue:res", err.response)
					
          //console.error("PPEHome.vue:mounted", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          //if(error.status === 401)
          //   this.$router.replace("/login?redirect="+error.config.url)
        })
    },



  methods: {
    ...common.methods,
    toDate(apiDate) { return Business.toDate(apiDate) },
    typeToText(type) {
          return Business.getOperationLabel(type)
    },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
    },
    getFullIndexInTable(i) {
      return this.perPage * (this.currentPage-1) + i
    },
  }
}
</script>